import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchContentPageByIdAction } from './actions/fetchContentPageById';

import {CommonContentPage} from './contentPage';

const mapStateToProps = (state: IState, ownProps: any) => ({
    contentPage: state.mainContent.currentContentPage,
    contentPageId: ownProps.params.id,
    errorDescription: state.mainContent.errorDescription
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchContentPageById: (id: string) => dispatch(fetchContentPageByIdAction(id))
});

export const CommonContentPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommonContentPage);


// WEBPACK FOOTER //
// ./src/components/contentPage/contentPageContainer.tsx